import React, { createRef } from "react";
import NormalSpin from "../../../base/basicComponents/spin";
import { flowCategoryId, actions } from "../../publicDictionaryValues";
import reasonEditDefaultIcon from "../../../assets/image/reasonEditIcon.png";
import styles from "../procedureFileProcess/style/index.module.scss";
import ProcessBase from "../../commonComponents/processBase/index";
import ApproveApplyJb from "./approveApplyJb";
import ApproveApplyForJbComplete from "./approveCompleteApplyJb";
import SubmitApplyForJbComplete from "./submitCompleteApplyJb";
import applyForJbService from "../../../service/applyForJb/applyForJbService";
import "./index.scss";
import LostPermissionModal from "../../sections/lostPermissionModal";
import CompleteStepBusinessType from "../../../service/stepBase/completeStepBusinessType";
import StepService from "../../../service/stepBase/StepService";
import ApplyForJbStepService from "../../../service/applyForJb/applyForJbStepService";

const procedureReplaceFileRef = createRef();
const procedureRef = createRef();
const procedureServerPathRef = createRef();
const procedureSavedInRef = createRef();
const approvePageRef = createRef();

export default class ApplyForJbProcess extends ProcessBase {
  constructor(props: any) {
    super(props);
    this.setGlobalVariables();
    this.initProcedureFileState();
    // @ts-ignore
    this.procedureFileStepID = null;
    // @ts-ignore
    this.initProcedureTableData = [];
  }

  /**
   * Set Component Global Variables
   */
  setGlobalVariables = () => {
    // @ts-ignore
    this.initSavedInSectionState = {
      savedInRadioValue: null,
    };

    // @ts-ignore
    this.primitiveSavedInSectionState = JSON.parse(JSON.stringify(this.initSavedInSectionState));

    // @ts-ignore
    this.initServerPathSectionState = {
      serverPathValue: null,
    };

    // @ts-ignore
    this.primitiveServerPathSectionState = JSON.parse(
      JSON.stringify(this.initServerPathSectionState)
    );

    // @ts-ignore
    this.initProcedureFileTableState = {
      returnedList: [],
      fileTableJbStatus: null,
      fileTableReturned: false,
      fileTableReturnReasonValue: null,
      fileTableReasonStatus: null,
      attachment: {},
    };
  };

  initApplyJbPageState = () => {
    return {
      flowCategoryID: null,
      requestByID: null,
      requestByName: null,
      uploadProcedureFileNum: 0,
      procedureFileNum: 0,
      receiveDate: null,
      actionName: null,
      procedureStatus: null,
      isSaveDisabled: false,
      isCancelDisabled: false,
      isSubmitDisabled: false,
      isRejectDisabled: false,
      rejectReason: null,
      rejectStatus: null,
      currentRole: null,
      procedureFolder: {},
      loading: false,
      procedureStepStatus: null,
      procedureID: null,
      procedureProcessId: null,
      procedureStepID: null,
      procedureNote: "",
    };
  };

  /**
   * Init Component State
   */
  initProcedureFileState = () => {
    this.state = {
      pageState: this.initApplyJbPageState(),
      initTableDate: {},
      isReturnReasonLogOpen: false,
      ppoList: [],
      applyJBStatus: {},
      taskInfoData: {},
      procedureFileData: {},
      procedureInfoData: {},
      fileTableData: [],
      supportingTableData: [],
      // @ts-ignore
      procedureFileTableState: this.initProcedureFileTableState,
      // @ts-ignore
      savedInSectionState: this.initSavedInSectionState,
      // @ts-ignore
      serverPathSectionState: this.initServerPathSectionState,
      shareTaskData: {},
      tlReviewData: {},
      noPermission: false,
    };
  };

  setSavedInServerPathState = (result: any) => {
    this.setState({
      savedInSectionState: {
        ...this.state.savedInSectionState,
        savedInRadioValue: result.procedureFolder?.procedureSaveInCategoryID || null,
      },
      serverPathSectionState: {
        ...this.state.serverPathSectionState,
        serverPathValue: result.procedureFolder?.clientServerPath || null,
      },
    });
  };

  /* function about adjust data when get data from api */
  handleDataNull = (file: any, key: any) => {
    if (file[key] === null) {
      if (key === "procedureFileID") {
        return 0;
      } else {
        return null;
      }
    } else {
      return file[key];
    }
  };

  setApplyJbInitProcedureTableData = () => {
    // @ts-ignore
    this.procedureTableData.forEach((item: any) => {
      // @ts-ignore
      this.initProcedureTableData.push({
        data: JSON.parse(JSON.stringify(item.data)),
        checked: item.checked,
        isApproveDisabled: item.isApproveDisabled,
        isReturnDisabled: item.isReturnDisabled,
        isReturned: item.isReturned,
        isError: item.isError,
        replaceRef: item.replaceRef,
        attachmentEditIcon: reasonEditDefaultIcon,
        isDelete: false,
        isUpdate: false,
      });
    });
  };

  setProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      // @ts-ignore
      this.procedureFileStepID = result.procedureFolder.procedureFileStepID;
      this.setProcedureTableData(result.procedureFolder);
      this.setApplyJbInitProcedureTableData();

      // @ts-ignore
      this.setState({ fileTableData: this.procedureTableData });
      this.setSavedInServerPathState(result);
    }
  };

  /**
   * Build SaveIn Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildSavedInSectionState = (data: any) => {
    return {
      savedInRadioValue: data.procedureSaveInCategoryID,
    };
  };

  /**
   * Build ServerPath Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildServerPathSectionState = (data: any) => {
    return {
      // @ts-ignore
      ...this.primitiveServerPathSectionState,
      serverPathValue: data.clientServerPath,
    };
  };

  _getFlowDataSuccess = (result: any) => {
    const { procedureStepStatus } = result;

    StepService.setStepInterfaceMergePayload(result, {
      isShareTaskProcess: false,
      isHistorical: procedureStepStatus === "Complete",
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    if (procedureStepStatus === "Complete") {
      ApplyForJbStepService.getExtensionKey = () => ({
        dataKey: "applyJBStatus",
        settingKey: "getApplyJBStatusStepCompletedItem",
      });
    }

    this.getInitData(
      applyForJbService.getApplyJBStatusStepItem,
      "Get Procedure Files Failed",
      undefined,
      result,
      StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.taskInfo.settingKey])
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get Procedure Files Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };
    applyForJbService.getFlowStepData(param, this._getFlowDataSuccess, this._getFlowDataFailed);
  };

  componentDidMount() {
    this.getFlowData();
  }

  /* function about get data from procedure file table */
  returnApplyJbFileDataValue = (name: any, index: any) => {
    // @ts-ignore
    const procedureFileData = procedureRef.current.getDataList();
    // @ts-ignore
    let deleteList = procedureRef.current.getDeleteList();
    let combineDatalist = procedureFileData.concat(deleteList);
    return combineDatalist[index].data.find((item: any) => item.name === name);
  };

  /* function about return submit data to use in integrate trigger api */
  handleReturnSubmitData = (actionID: any, actionName: any) => {
    const fileDtos: any[] = [];
    if (procedureRef.current !== null) {
      // @ts-ignore
      const procedureFileData = procedureRef.current.getDataList();
      // @ts-ignore
      let deleteList = procedureRef.current.getDeleteList();
      let combineDatalist = procedureFileData.concat(deleteList);
      combineDatalist.forEach((item: any, index: any) =>
        fileDtos.push({
          fileID:
            this.returnApplyJbFileDataValue("newVersion", index).fileId === null
              ? this.returnApplyJbFileDataValue("fileId", index).value
              : this.returnApplyJbFileDataValue("newVersion", index).fileId,
          createdDate: this.returnApplyJbFileDataValue("uploadedDate", index).value,
          uploadBy: this.returnApplyJbFileDataValue("uploadById", index).value,
          uploadByName: this.returnApplyJbFileDataValue("uploadByName", index).value,
          fileName:
            this.returnApplyJbFileDataValue("newVersion", index).value === null
              ? this.returnApplyJbFileDataValue("fileName", index).value
              : this.returnApplyJbFileDataValue("newVersion", index).value,
          fileKey: this.returnApplyJbFileDataValue("fileKey", index).value,
          dataStatusID: this.returnApplyJbFileDataValue("status", index).value,
          attachmentFileID: this.returnApplyJbFileDataValue("attachment", index).fileId,
          attachmentName: this.returnApplyJbFileDataValue("attachment", index).value,
          returnReason: this.returnApplyJbFileDataValue("returnReason", index).value,
          fileTagID: this.returnApplyJbFileDataValue("fileName", index).tagValue,
          procedureFileStepID: this.returnApplyJbFileDataValue("procedureFileStepID", index).value,
          procedureFileID: this.returnApplyJbFileDataValue("procedureFileID", index).value,
          note: this.returnApplyJbFileDataValue("note", index).value,
          oldFileID:
            this.returnApplyJbFileDataValue("newVersion", index).fileId === null
              ? null
              : this.returnApplyJbFileDataValue("fileId", index).value,
          oldFileName:
            this.returnApplyJbFileDataValue("newVersion", index).value === null
              ? null
              : this.returnApplyJbFileDataValue("fileName", index).value,
          isDelete: item.isDelete,
          isUpdate: item.isUpdate,
        })
      );
    }
    let serverPathValue = null;

    if (procedureServerPathRef.current !== null) {
      // @ts-ignore
      const serverPathState = procedureServerPathRef.current.state.serverPathSectionState;
      serverPathValue = serverPathState.serverPathValue;
    }

    // @ts-ignore
    const { savedInRadioValue } = procedureSavedInRef.current.state.savedInSectionState;
    return {
      // @ts-ignore
      procedureId: this.procedureId,
      // @ts-ignore
      workflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      flowCategoryID: this.flowCategoryID,
      actionName: actionName,
      actionID: actionID,
      accountID: null,
      // @ts-ignore
      rejectReason:
        approvePageRef.current === null
          ? null
          : approvePageRef.current.state.pageState.rejectReason,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      clientServerPath: serverPathValue,
      procedureSaveInCategoryID: savedInRadioValue,
      // @ts-ignore
      isInitial: this.isRevisePage,
      procedureFiles: fileDtos,
      // @ts-ignore
      procedureFileStepID: this.procedureFileStepID,
    };
  };

  setApplyJbData = (result: any) => {
    this.setState({
      applyJBStatus: result.applyJBStatus,
    });
  };

  setSupportingFileData = (result: any) => {
    this.setSupportingTableData(result);
    this.setState({
      // @ts-ignore
      supportingTableData: this.supportingTableData,
    });
  };

  handleApplyJbPageProps = () => {
    const {
      receiveDate,
      requestByName,
      procedureStepStatus,
      procedureStatus,
      rejectStatus,
      currentRole,
      flowCategoryID,
    } = this.state.pageState;

    return {
      flowCategoryID,
      receiveDate,
      requestByName,
      procedureStatus,
      rejectStatus,
      currentRole,
      procedureReplaceFileRef,
      isDisableAll: true,
      procedureStepStatus,
    };
  };

  handleApplyJbSectionProps = () => {
    const { taskInfoData, procedureInfoData } = this.state;

    return {
      taskInfoData,
      procedureInfoData,
      ppoList: this.state.ppoList,
    };
  };

  handleApplyJbParams = () => {
    return {
      // @ts-ignore
      ProcedureTaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
      // @ts-ignore
      ProcedureFileStepID: this.procedureFileStepID,
      // @ts-ignore
      WorkflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      FlowCategoryID: this.flowCategoryID,
    };
  };

  handleApplyJbApprovePage = (procedureTableData: any) => {
    const { shareTaskData, applyJBStatus } = this.state;

    const { procedureProcessId } = this.state.pageState;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    return (
      // @ts-ignore
      <ApproveApplyJb
        pageProps={{ ...this.handleApplyJbPageProps(), procedureProcessId }}
        sectionProps={this.handleApplyJbSectionProps()}
        savedInProps={{
          savedInRadioValue,
        }}
        serverPathProps={{
          serverPathValue,
        }}
        returnFileDataValue={this.returnApplyJbFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        params={this.handleApplyJbParams()}
        shareTaskData={shareTaskData}
        fileTableData={procedureTableData}
        supportingTableData={this.state.supportingTableData}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        applyJBStatus={applyJBStatus}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        closePage={this.closePage}
        setPermission={(result: any) => this.setState({ noPermission: result })}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleApplyJbApproveCompltePage = (procedureTableData: any) => {
    const { shareTaskData, applyJBStatus } = this.state;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    // @ts-ignore
    const isCopyPage = this.flowCategoryID && this.flowCategoryID === flowCategoryId.copyJBStatus;
    // @ts-ignore
    const isTeminationCompletePage = this.actionID === actions.systemTermination;

    return (
      // @ts-ignore
      <ApproveApplyForJbComplete
        pageProps={this.handleApplyJbPageProps()}
        sectionProps={this.handleApplyJbSectionProps()}
        savedInProps={{
          savedInRadioValue,
        }}
        serverPathProps={{
          serverPathValue,
        }}
        applyJBStatus={applyJBStatus}
        closePage={this.closePage}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        fileTableData={procedureTableData}
        shareTaskData={shareTaskData}
        supportingTableData={this.state.supportingTableData}
        params={this.handleApplyJbParams()}
        returnFileDataValue={this.returnApplyJbFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        isCopyPage={isCopyPage}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
        isApproveCompletePage={true}
        isTeminationCompletePage={isTeminationCompletePage}
      />
    );
  };

  handleApplyJbSubmitCompltePage = (procedureTableData: any) => {
    const { shareTaskData, applyJBStatus } = this.state;

    const { savedInRadioValue } = this.state.savedInSectionState;
    const { serverPathValue } = this.state.serverPathSectionState;

    // @ts-ignore
    const isCopyPage = this.flowCategoryID && this.flowCategoryID === flowCategoryId.copyJBStatus;

    return (
      // @ts-ignore
      <SubmitApplyForJbComplete
        pageProps={this.handleApplyJbPageProps()}
        sectionProps={this.handleApplyJbSectionProps()}
        params={this.handleApplyJbParams()}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        savedInProps={{
          savedInRadioValue,
        }}
        serverPathProps={{
          serverPathValue,
        }}
        returnFileDataValue={this.returnApplyJbFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        applyJBStatus={applyJBStatus}
        closePage={this.closePage}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        fileTableData={procedureTableData}
        shareTaskData={shareTaskData}
        supportingTableData={this.state.supportingTableData}
        isCopyPage={isCopyPage}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
        isSubmitCompletePage={true}
      />
    );
  };

  handleApplyJbProcedureTableData = () => {
    return JSON.parse(JSON.stringify(this.state.fileTableData));
  };

  render() {
    const { loading, procedureFileNum, uploadProcedureFileNum, procedureStepStatus } =
      this.state.pageState;

    const procedureTableData = this.handleApplyJbProcedureTableData();

    const isApprovePendingPage = procedureStepStatus === "Pending";
    // @ts-ignore
    const isApproveCompletePage = procedureStepStatus === "Complete" && this.triggerTimes > 1;
    // @ts-ignore
    const isSubmitCompletePage = procedureStepStatus === "Complete" && this.triggerTimes === 1;

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        indicator={
          procedureFileNum > 0 ? (
            <p className={styles.loadingText}>
              Uploading {uploadProcedureFileNum}/{procedureFileNum} file
            </p>
          ) : undefined
        }
        children={
          <>
            {isApprovePendingPage && this.handleApplyJbApprovePage(procedureTableData)}
            {isApproveCompletePage && this.handleApplyJbApproveCompltePage(procedureTableData)}
            {isSubmitCompletePage && this.handleApplyJbSubmitCompltePage(procedureTableData)}
            <LostPermissionModal isModalOpen={this.state.noPermission} />
          </>
        }
      />
    );
  }
}
